module.exports = __webpack_public_path__ + "static/media/weight-down.f2031dc9.png";